import * as Yup from 'yup';
import {
  optionalText,
  requiredMultiSelect,
  requiredSelect,
  requiredText,
} from './CommonValidation';

/** @constant {ObjectShape} - Yup Object used for validationScheme in signup procedure */
const DatasetScheme = Yup.object().shape({
  // datasetName: Yup.string().trim().required('Dataset Name is required'),
  // owningTeam: Yup.string().trim().required('Owning Team is required'),
  // contactperson: Yup.string().trim().required('Contact person is required'),
  // sourcetype: Yup.string().trim().required('Source type is required'),
  // risktier: Yup.string().trim().required('Risk tier is required'),
  // w3ccredentials: Yup.string()
  //   .trim()
  //   .required('Watermarking Technique is required'),
  // purposeofuse: Yup.string().trim().required('Purpose of use is required'),
  // sensitivityclass: Yup.string()
  //   .trim()
  //   .required('Sensitivity Classification is required'),
  // datamodalities: Yup.array()
  //   .required('Data modalities is required')
  //   .min(1, 'Please select atleast one'),
  // datamodalitiescustom: Yup.string(),
  // volumesize: Yup.string().required('Volume is required'),
  // geographicorigin: Yup.string().required('Geographic input is required'),
  // sensitivitytype: Yup.array()
  //   .required('Sensitivity Data types is required')
  //   .min(1, 'Please select atleast one'),
  // sensitivitycollection: Yup.string().required('Data collection is required'),
  // sourcedetails: Yup.string().required('Source details is required'),
  // lifecyclestage: Yup.string().required('Lifecycle stage is required'),
  // downstream: Yup.string().required('Downstream Depedencies is required'),
  // frequency: Yup.string().required('Frequency is required'),
  // inplace: Yup.string().required('Monitoring in place input is required'),
  // approval: Yup.string().trim().required('Approval status is required'),
  // dataqualityissue: Yup.string().required('Known data qualities is required'),
  // validationsummary: Yup.string().required('Validation summary is required'),
  // dictionarylink: Yup.string()
  //     .required('Dictionary link is required')
  //     .url('Dictionary link must be a valid URL'),
  // accessControl: Yup.string().required('Access control is required'),
  // encryption: Yup.string().required('Encryption is required'),
  // retentionpolicy: Yup.string().required('Retention Policy is required'),
  // sharingrestriction: Yup.string().required(
  //     'Sharing restrictions is required'
  // ),
  // compliancetags: Yup.string().required('Compliance tags is required'),
  // compliancetagscustom: Yup.string(),

  datasetName: requiredText('Dataset Name', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  owningTeam: requiredText('Owning Team', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  contactperson: requiredText('Contact person', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  purposeofuse: requiredText('Purpose of use', {
    minLength: 10,
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),

  sourcetype: requiredSelect('Source type'),
  risktier: requiredSelect('Risk tier'),
  w3ccredentials: requiredSelect('Watermarking Technique'),
  sensitivityclass: requiredSelect('Sensitivity Classification'),
  approval: requiredSelect('Approval status'),

  datamodalities: requiredMultiSelect('Data modalities'),
  sensitivitytype: requiredMultiSelect('Sensitivity Data types'),

  sourcedetails: optionalText('Source details', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  geographicorigin: optionalText('Geographic Origin', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  sensitivitycollection: optionalText('Data Collection Method', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  dataqualityissue: optionalText('Known Data Quality Issues', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  validationsummary: optionalText('Validation Summary', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  downstream: optionalText('Downstream Dependencies', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  frequency: optionalText('Review Frequency', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  inplace: optionalText('Monitoring In Place', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  accessControl: optionalText('Access Controls', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  encryption: optionalText('Encryption', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  retentionpolicy: optionalText('Retention Policy', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
  sharingrestriction: optionalText('Sharing Restrictions', {
    allowNumbers: true,
    allowSpecialCharacters: true,
  }),
});

export { DatasetScheme };
